import axios from "axios";

export const getAllCommerce = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/api/commerce/get-all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al obtener comercios";
  }
};

export const createCommerceService = async (userData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token provided");
  try {
    const { data } = await axios.post(`${API_URL}/api/commerce`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear comercio");
  }
};

export const updateCommerceService = async (id, userData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.put(`${API_URL}/api/commerce/${id}`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al actualizar usuario";
  }
};

export const deleteCommerceService = async (userId) => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No hay token de autenticación");
  }

  try {
    const response = await axios.delete(`${API_URL}/api/commerce/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Error al marcar el comercio como eliminado";
    throw new Error(errorMessage);
  }
};
